var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from "app/views/base.service";
import { HttpClient } from "@angular/common/http";
var PeriodService = /** @class */ (function (_super) {
    __extends(PeriodService, _super);
    function PeriodService(http) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.period = 'day';
        return _this;
    }
    return PeriodService;
}(BaseService));
export { PeriodService };
